import { SPORT_RULESETS } from '../data/sportRulesets';
import type { Team } from '../types/core';

/**
 * Regulation inning count for per-game baseball/softball fielding (team setting, else ruleset).
 * Matches GameDetailView behavior.
 */
export function getGameFieldingInningsCount(team: Pick<Team, 'sport' | 'innings'> | null | undefined): number {
  const sport = team?.sport === 'Softball' ? 'Softball' : 'Baseball';
  const rulesetDefault = SPORT_RULESETS[sport].defaultInnings ?? 7;
  if (!team || (team.sport !== 'Baseball' && team.sport !== 'Softball')) {
    return rulesetDefault;
  }
  const n = Number(team.innings);
  if (Number.isFinite(n) && n > 0) return n;
  return rulesetDefault;
}
